import React from 'react';
import autoBind from 'react-autobind';
import Formatter from '../../utils/Formatter.js';
import _ from 'lodash';
const d3 = require('d3');

export default class AllocationChart extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = {
			dimension: 300
		};
	}

	componentDidMount() {
		window.addEventListener('resize', this.updateDimensions);
		this.updateDimensions();
	}

	componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

	updateDimensions() {
		const wW = window.innerWidth;
		let dimension = (this.state && this.state.dimension) || 300;
		if (wW < 768) { // Mobile
			dimension = parseInt(wW - 30); // padding (30 * 1)
		} else if (wW >= 768 && wW < 992) { // Tablet
			dimension = parseInt(650) // container 680, padding (15 * 2)
		} else {
			dimension = 300;
		}
		this.setState({ dimension: dimension });
	}

	getAllocationSet(pie, arcData) {
		// https://github.com/d3/d3-shape/blob/master/README.md#pie

        const width = this.state.dimension,
			ratio = (300 * 0.33),
			height = 300,
			radius = Math.min(width, height) / 2,
			items = pie(_.pluck(arcData, 'percent')),
			arc = d3.arc().innerRadius(ratio).outerRadius(radius),
			set = items.map(function (e, index) {
				const d = arc(e),
					style = _.camelCase(arcData[index].name);
				return React.createElement(
					'path',
					{
						key: ('allocation-item__' + index),
						className: style,
						d: d
					}
				);
			});

		return set;
	}
    
	renderAllocations(allocationSet) {
		const all = _.map(allocationSet, (alloc, idx) => {
			const allocClass = 'investment-allocation-chart__allocColor ' + _.camelCase(alloc.name),
				key = 'inv-alloc-chart__alloc-' + idx;
			let allocAmountFormatted = Formatter.currencyFormat(alloc.amount.toFixed(2), true);
            let allocPercentFormatted = alloc.percent.toFixed(2) + '%';
			return (
                <div key={key} className="row investment-allocation-chart__allocations">
                    <div className="col-xs-6">
                        <span className={allocClass} /><span className="investment-allocation-chart__label">{alloc.displayName}</span>
                    </div>
                    <div className="col-xs-3 investment-allocation-chart__percent">{allocPercentFormatted}</div>
                    <div className="col-xs-3 investment-allocation-chart__amount">{allocAmountFormatted}</div>
                </div>);
		});
		return all;
	}

	renderPieChart(allocationSet) {
		const width = this.state.dimension,
			height = 300,
			transformAnimation = 'translate(' + width / 2 + ',' + height / 2 + ')',
			pie = d3.pie(),
			dataset = _.omit(allocationSet, 'amount');

		const allAllocations = this.getAllocationSet(pie, dataset);

		var Chart = React.createElement(
            'svg',
            { ref: 'AllocationChart', width: width, height: height, margin: { left: 0, right: 0, top: 0, bottom: 0 }, preserveAspectRatio: 'none' },
            React.createElement(
                'g',
                { transform: transformAnimation },
				allAllocations
            )
        );

		return Chart;
	}

    render() {
        if (this.props.aggregatedAllocations.length === 0) {
			return null;
		}
        const totalAmountFormatted = Formatter.currencyFormat(this.props.totalAmount.toFixed(2));
        const chart = this.renderPieChart(this.props.aggregatedAllocations);
        const allocations = this.renderAllocations(this.props.aggregatedAllocations);

		return (
			<section className="investment-allocation-chart">
				<div className="investment-allocation-chart__chartContainer">
					<div className="row">
						<div className="col-xs-12">
							<div className="alert alert-info" role="alert"><strong>Note: </strong>{this.props.message}</div>
						</div>
					</div>
                    <div className="row">
						<div className="col-xs-12 col-md-4 investment-allocation-chart__chartTitle">
							{this.props.title}
						</div>
					</div>
					<div className="row">
						<div className="col-xs-12 col-md-4 investment-allocation-chart__chart">
							<div className="investment-allocation-chart__totalAmount">{'$' + totalAmountFormatted}</div>
							{chart}
						</div>
						<div className="col-xs-12 col-md-8 investment-allocation-chart__legendContainer">
							<div className="row investment-allocation-chart__legend">
								<div className="col-xs-6 investment-allocation-chart__legendTitle">Asset Class</div>
								<div className="col-xs-3 investment-allocation-chart__legendTitle">Percentage</div>
								<div className="col-xs-3 investment-allocation-chart__legendTitle">Value</div>
							</div>
							{allocations}</div>
					</div>
				</div>
			</section>
		)
    }
}

AllocationChart.propTypes = {
	totalAmount: React.PropTypes.number.isRequired,
    aggregatedAllocations: React.PropTypes.array.isRequired, 
	message: React.PropTypes.string.isRequired,
	title: React.PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ConfirmDetails/AllocationChart.jsx